
import { useState, useEffect } from 'react';
import { Button, Table, Popconfirm, message, Tag, Pagination, Modal, Input, Radio, Checkbox } from 'antd';
import { FolderAddOutlined } from '@ant-design/icons';
import { Role } from '@/interface/role';
import Https from '@/https';
import './User.css';
export default function UserList() {
  const [messageApi, messageContextHolder] = message.useMessage();
  const regPhone = /^1[3-9]\d{9}$/;
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const userColumns = [
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '登录账号',
      dataIndex: 'account',
      key: 'account',
    },
    {
      title: '联系电话',
      dataIndex: 'phone',
      key: 'phone',
      width: 150,
    },
    {
      title: '角色',
      dataIndex: 'roleName',
      key: 'roleName',
      width: 150,
      render: (text: any, record: any) => {
        return (
          <>
            {record.roles && record.roles.map((item: any) => {
              return <span key={item.id} style={{marginRight: '10px'}}>{item.name}</span>;
            })}
          </>
        );
      }
    },
    {
      title: '有效日期',
      dataIndex: 'expireDateName',
      key: 'expireDateName',
      width: 150,
    },
    {
      title: '是否激活',
      dataIndex: 'isActive',
      key: 'isActive',
      width: 120,
      render: (text: any, record: any) => {
        return record.isActive ? <Tag color="green">是</Tag> : <Tag color="red">否</Tag>;
      }
    },
    {
      title: '操作',
      key: 'action',
      dataIndex: 'action',
      width: 300,
      fixed: 'right' as const,
      render: (text: any, record: any) => {
        return (
          <>
            <Button color="primary" variant="link" size="small" onClick={() => handleSetRole(record)}>设置角色</Button>
            <Popconfirm
              title="提示"
              description="确定重置密码?"
              onConfirm={() => handleResetPwd(record)}
              okText="确定"
              cancelText="取消">
                <Button color="purple" variant="link" size="small">重置密码</Button>
            </Popconfirm>
            <Button color="cyan" variant="link" size="small" onClick={() => handleUserEdit(record)}>编辑</Button>
            <Popconfirm
              title="提示"
              description="确定删除人员?"
              onConfirm={() => confirmRemove(record)}
              okText="确定"
              cancelText="取消">
                <Button color="danger" variant="link" size="small">删除</Button>
            </Popconfirm>
          </>
        )
      }
    }
  ]

  const [toggleReset, setToggleReset] = useState(false);
  const reset = () => {
    setPageIndex(1);
    setName('');
    setPhone('');
    setToggleReset(true);
  }

  const search = () => {
    setPageIndex(1);
    getUserList();
  }

  const handleResetPwd = (record: any) => {
    Https.post({
      url: 'Api/URPM/V1/User/ResetPassword',
      data: {
        userId: record.id,
      }
    }).then(res => {
      if(res.state === 1) {
        messageApi.success('重置密码成功');
        getUserList();
      } else {
        messageApi.error(res.data.errorMessage || res.errorMessage);
      }
    })
  }

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editName, setEditName] = useState('');
  const [editPhone, setEditPhone] = useState('');
  const [editAccount, setEditAccount] = useState('');
  const [editIsActive, setEditIsActive] = useState(1);
  const [userId, setUserId] = useState('');

  const resetEditInfo = () => {
    setEditName('');
    setEditPhone('');
    setEditAccount('');
    setEditIsActive(1);
    setUserId('');
  }
  const handleUserEdit = (record: any) => {
    setEditName(record.name);
    setEditPhone(record.phone);
    setEditAccount(record.account);
    setEditIsActive(record.isActive ? 1 : 0);
    setUserId(record.id);
    setIsEditModalOpen(true);
  }

  const handleEditOk = () => {
    if(editPhone && !regPhone.test(editPhone)) {
      messageApi.error('请输入正确的手机号');
      return;
    }
    Https.post({
      url: 'Api/URPM/V1/User/Update',
      data: {
        userId,
        name: editName,
        phone: editPhone,
        account: editAccount,
        isActive: editIsActive,
        isSystemRole: false,
        platformType: 1,
      }
    }).then(res => {
      if(res.state === 1) {
        messageApi.success('编辑成功');
        getUserList();
        setIsEditModalOpen(false);
      } else {
        messageApi.error(res.data.errorMessage || res.errorMessage);
      }
    })
  }

  const handleEditCancel = () => {
    resetEditInfo();
    setIsEditModalOpen(false);
  }

  const confirmRemove = (record: any) => {
    Https.post({
      url: 'Api/URPM/V1/User/Delete',
      data: {
        userId: record.id,
      }
    }).then(res => {
      if(res.state === 1) {
        messageApi.success('删除成功');
        getUserList();
      } else {
        messageApi.error(res.data.errorMessage || res.errorMessage);
      }
    })
  }

  const getUserList = () => {
    setLoading(true);
    Https.post({
      url: 'Api/URPM/V1/User/FindBy',
      data: {
        pageIndex,
        pageSize,
        name,
        phone,
        platformType: 1,
      }
    }).then(res => {
      if(res.state === 1) {
        setTotal(res.data.totalCount);
        setUserList(res.data.users);
      } else {
        messageApi.error(res.data.errorMessage || res.errorMessage);
      }
    }).finally(() => {
      setLoading(false);
    })
  }

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [createName, setCreateName] = useState('');
  const [createPhone, setCreatePhone] = useState('');
  const [createAccount, setCreateAccount] = useState('');
  const [createIsActive, setCreateIsActive] = useState(1);

  const resetCreateInfo = () => {
    setCreateName('');
    setCreatePhone('');
    setCreateAccount('');
    setCreateIsActive(1);
  }
  const createUser = () => {
    resetCreateInfo();
    setIsCreateModalOpen(true);
  }

  const handleCreateOk = () => {
    if(createPhone && !regPhone.test(createPhone)) {
      messageApi.error('请输入正确的手机号');
      return;
    }
    Https.post({
      url: 'Api/URPM/V1/User/Create',
      data: {
        name: createName,
        phone: createPhone,
        account: createAccount,
        isActive: createIsActive,
        isSystemRole: false,
        platformType: 1,
      }
    }).then(res => {
      if(res.state === 1) {
        messageApi.success('添加成功');
        setIsCreateModalOpen(false);
        resetCreateInfo();
        getUserList();
      } else {
        messageApi.error(res.data.errorMessage || res.errorMessage);
      }
    })
  }
  const handleCreateCancel = () => {
    setIsCreateModalOpen(false);
    resetCreateInfo();
  }

  const [isSetRoleModalOpen, setIsSetRoleModalOpen] = useState(false);
  const [roleList, setRoleList] = useState<Role[]>([]);
  const [roleType, setRoleType] = useState(0);
  const [roleIds, setRoleIds] = useState<string[]>([]);
  const [userIdForRole, setUserIdForRole] = useState('');
  const [userNameForRole, setUserNameForRole] = useState('');
  const getRoleList = () => {
    Https.post({
      url: 'Api/URPM/V1/Role/List/By',
      data: {
        isActive: 1
      }
    }).then(res => {
      if(res.state === 1) {
        setRoleList(res.data.roles);
      }
    })
  }

  const handleSetRole = (record: any) => {
    let roleIds = record.roles?.map((item: any) => item.id);
    resetSetRoleInfo();
    setUserIdForRole(record.id);
    setUserNameForRole(record.name);
    setRoleIds(roleIds);
    setIsSetRoleModalOpen(true);
  }

  const resetSetRoleInfo = () => {
    setUserIdForRole('');
    setRoleIds([]);
  }
  const handleSetRoleOk = () => {
    Https.post({
      url: 'Api/URPM/V1/SysAuthorize/UserRole/Create',
      data: {
        userId: userIdForRole,
        roleIds,
        terminal: 1,
        companyRole: 1,
        userName: userNameForRole,
        isSystemRole: roleType,
      }
    }).then(res => {
      if(res.state === 1) {
        messageApi.success('设置成功');
        setIsSetRoleModalOpen(false);
        resetSetRoleInfo();
        getUserList();
      } else {
        messageApi.error(res.data.errorMessage || res.errorMessage);
      }
    })
  }
  const handleSetRoleCancel = () => {
    setIsSetRoleModalOpen(false);
    setUserIdForRole('');
    setRoleIds([]);
  }

  useEffect(() => {
    getRoleList();
    getUserList();
  }, [])

  useEffect(() => {
    if(toggleReset) {
      getUserList();
      setToggleReset(false);
    }
  }, [toggleReset])

  useEffect(() => {
    getUserList();
  }, [pageIndex, pageSize])

  return (
    <section className="User">
      <section className="user-search">
        <section className="search-box">
          <section className="search-item">
            <span className="search-label small-label">姓名</span>
            <Input placeholder="请输入姓名" value={name} allowClear onChange={(e) => setName(e.target.value)} />
          </section>
          <section className="search-item">
            <span className="search-label">联系电话</span>
            <Input placeholder="请输入联系电话" value={phone} allowClear onChange={(e) => setPhone(e.target.value)} />
          </section>
        </section>
        <section className="search-btns">
          <Button onClick={reset}>重置</Button>
          <Button type="primary" onClick={search}>查询</Button>
          <Button type="primary" icon={<FolderAddOutlined />} onClick={() => createUser()}>添加人员</Button>
        </section>
      </section>
      <section>
        <Table
          dataSource={userList}
          rowKey="id"
          columns={userColumns}
          pagination={false}
          scroll={{x: 'max-content', y: 'calc(100vh - 320px)'}}
          loading={loading}
         />
      </section>
      <section className="page-box">
        <Pagination
          align="end"
          total={total}
          showTotal={(total) => `共 ${total} 条`}
          defaultPageSize={20}
          defaultCurrent={1}
          onChange={(page, pageSize) => {
            setPageIndex(page);
            setPageSize(pageSize);
          }}
        />
      </section>
      <Modal
        title="添加人员"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isCreateModalOpen}
        onOk={handleCreateOk}
        onCancel={handleCreateCancel}
        destroyOnHidden={true}
        okButtonProps={{
          disabled: !createName || !createAccount
        }}>
        <section className="modal-form-item">
          <span className="label required">姓名</span>
          <Input placeholder="请输入姓名" value={createName} allowClear onChange={(e) => setCreateName(e.target.value)} />
        </section>
        <section className="modal-form-item">
          <span className="label required">登录账号</span>
          <Input placeholder="请输入登录账号" value={createAccount} allowClear onChange={(e) => setCreateAccount(e.target.value)} />
        </section>
        <section className="modal-form-item">
          <span className="label">默认密码</span>
          <span>12345678Aa!</span>
        </section>
        <section className="modal-form-item">
          <span className="label">联系电话</span>
          <Input placeholder="请输入联系电话" value={createPhone} allowClear onChange={(e) => setCreatePhone(e.target.value)} />
        </section>
        <section className="modal-form-item">
          <span className="label">是否激活</span>
          <Radio.Group
            value={createIsActive}
            options={[
              { value: 1, label: '是' },
              { value: 0, label: '否' },
            ]}
            onChange={(e) => setCreateIsActive(e.target.value)}
          />
        </section>
      </Modal>
      <Modal
        title="编辑人员"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isEditModalOpen}
        onOk={handleEditOk}
        onCancel={handleEditCancel}
        destroyOnHidden={true}
        okButtonProps={{
          disabled: !editName || !editAccount
        }}>
        <section className="modal-form-item">
          <span className="label required">姓名</span>
          <Input placeholder="请输入姓名" value={editName} allowClear onChange={(e) => setEditName(e.target.value)} />
        </section>
        <section className="modal-form-item">
          <span className="label required">登录账号</span>
          <Input placeholder="请输入登录账号" disabled value={editAccount} allowClear onChange={(e) => setEditAccount(e.target.value)} />
        </section>
        <section className="modal-form-item">
          <span className="label">联系电话</span>
          <Input placeholder="请输入联系电话" value={editPhone} allowClear onChange={(e) => setEditPhone(e.target.value)} />
        </section>
        <section className="modal-form-item">
          <span className="label">是否激活</span>
          <Radio.Group
            value={editIsActive}
            options={[
              { value: 1, label: '是' },
              { value: 0, label: '否' },
            ]}
            onChange={(e) => setEditIsActive(e.target.value)}
          />
        </section>
      </Modal>
      <Modal
        title="设置角色"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isSetRoleModalOpen}
        onOk={handleSetRoleOk}
        onCancel={handleSetRoleCancel}
        destroyOnHidden={true}
        okButtonProps={{
          disabled: !userIdForRole.length
        }}>
          {/* <section>
            <Radio.Group
              value={roleType}
              options={[
                { value: 0, label: '自定义角色' },
                { value: 1, label: '系统默认角色' },
              ]}
              onChange={(e) => setRoleType(e.target.value)}
            />
          </section> */}
          <section>
            {
              <Checkbox.Group style={{ width: '100%' }} onChange={(e) => setRoleIds(e)} value={roleIds}>
                {
                  roleList.map((item, index) => (
                    <Checkbox key={item.id} value={item.id}>{item.name}</Checkbox>
                  ))
                }
              </Checkbox.Group>
            }
          </section>
      </Modal>
      { messageContextHolder}
    </section>
  )
}